import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import dateTimeConstants from 'constants/dateTime';

dayjs.extend(utc);

const { DATE_TIME_SLASH_FORMAT } = dateTimeConstants;

const formatDateTime = (
  time: string | Dayjs | number,
  format: string = DATE_TIME_SLASH_FORMAT
) => {
  return dayjs(time).format(format);
};

export default {
  formatDateTime,
};
